import { compareServiceSegments } from '../data-sorting';
import { Language, Market, MarketsConfig, ServiceSegmentType } from '../types';

export const marketsConfig: MarketsConfig = {
  [Market.DE]: {
    languages: [
      {
        code: Language.DE,
        domain: 'https://www.mewa.de',
        // localizedMarketName: 'Mewa Deutschland',
        // customerPortal: 'https://my.mewa.de/de/login',
        // careerPortal: 'https://mewa.jobs/',
        // onlineShop: 'https://buy4work.mewa.shop/de/de',
        // facebook: 'https://www.facebook.com/MEWADienstleistung/',
        // instagram: 'https://www.instagram.com/mewa_textilservice/',
        // kununu: 'https://www.kununu.com/de/mewa-textil-service-management',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
        // x: 'https://x.com/mewa_de',
        // xing: 'https://www.xing.com/pages/mewa',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // blog: 'true',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.businessClothing,
      ServiceSegmentType.protectiveClothing,
      ServiceSegmentType.serviceClothing,
      ServiceSegmentType.workwear,
      ServiceSegmentType.hygieneClothing,
      ServiceSegmentType.washroomHygiene,
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.dirtTrappingMats,
      ServiceSegmentType.cleaningCloths,
      ServiceSegmentType.carCovers,
      ServiceSegmentType.wipingMops,
      ServiceSegmentType.partsCleaner,
      // Custom service segment created in the gatsby-source-pim plugin because it's currently not maintained in the PIM system.
      // This will be empty after fetching the data from the pim and will be removed in the gatsby-source-pim, if there are no products.
      ServiceSegmentType.healthClothing,
      ServiceSegmentType.cleanRoomClothing,
      ServiceSegmentType.cleanRoomAccessories,
      ServiceSegmentType.cleanRoomCleaning,
      ServiceSegmentType.cleanRoomTrainings,
    ].sort(compareServiceSegments),
    hasClothingSegments: true,
    countryCallingCode: '+49',
    maxEmployeeCountForSmallCompany: 124,
  },
  [Market.FR]: {
    languages: [
      {
        code: Language.FR,
        domain: 'https://www.mewa.fr',
        // localizedMarketName: 'Mewa France',
        // customerPortal: 'https://my.mewa.fr/fr/login',
        // careerPortal: 'https://mewa.jobs/fr',
        // onlineShop: 'https://buy4work.mewa.shop/fr/fr',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
        // x: 'https://x.com/mewa_fr',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.protectiveClothing,
      ServiceSegmentType.serviceClothing,
      ServiceSegmentType.workwear,
      ServiceSegmentType.healthClothing,
      ServiceSegmentType.hygieneClothing,
      ServiceSegmentType.washroomHygiene,
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.dirtTrappingMats,
      ServiceSegmentType.cleaningCloths,
      ServiceSegmentType.carCovers,
      ServiceSegmentType.partsCleaner,
    ].sort(compareServiceSegments),
    hasClothingSegments: true,
    countryCallingCode: '+33',
    maxEmployeeCountForSmallCompany: 124,
  },
  [Market.IT]: {
    languages: [
      {
        code: Language.IT,
        domain: 'https://www.mewa.it',
        // localizedMarketName: 'Mewa Italia',
        // customerPortal: 'https://my.mewa.it/it/login',
        // careerPortal: 'https://mewa.jobs/it',
        // onlineShop: 'https://buy4work.mewa.shop/it/it',
        // facebook: 'https://www.facebook.com/MEWAItalia/',
        // x: 'https://x.com/mewa_it',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.protectiveClothing,
      ServiceSegmentType.serviceClothing,
      ServiceSegmentType.workwear,
      ServiceSegmentType.healthClothing,
      ServiceSegmentType.hygieneClothing,
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.dirtTrappingMats,
      ServiceSegmentType.cleaningCloths,
      ServiceSegmentType.carCovers,
      ServiceSegmentType.partsCleaner,
    ].sort(compareServiceSegments),
    hasClothingSegments: true,
    countryCallingCode: '+39',
    maxEmployeeCountForSmallCompany: 124,
  },
  [Market.HU]: {
    languages: [
      {
        code: Language.HU,
        domain: 'https://www.mewa.hu',
        // localizedMarketName: 'Mewa Magyarország',
        // customerPortal: 'https://my.mewa.hu/hu/login',
        // careerPortal: 'https://mewa.jobs/hu',
        // onlineShop: 'https://buy4work.mewa.shop/hu/hu',
        // x: 'https://x.com/mewa_hu',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.cleaningCloths,
      ServiceSegmentType.wipingMops,
      ServiceSegmentType.partsCleaner,
    ].sort(compareServiceSegments),
    hasClothingSegments: false,
    countryCallingCode: '+36',
    maxEmployeeCountForSmallCompany: 124,
  },
  [Market.CH]: {
    languages: [
      {
        code: Language.DE,
        domain: 'https://www.mewa.ch',
        langPrefix: Language.DE,
        cmsFallback: Market.DE,
      },
      {
        code: Language.FR,
        cmsFallback: Market.FR,
        domain: 'https://www.mewa.ch',
        langPrefix: Language.FR,
        // localizedMarketName: 'Mewa Suisse',
        // localizedLanguageLabel: 'Français',
        // customerPortal: 'https://my.mewa.ch/fr/login',
        // careerPortal: 'https://mewa.jobs/fr',
        // onlineShop: 'https://buy4work.mewa.shop/ch/fr',
        // facebook: 'https://www.facebook.com/MEWADienstleistung/',
        // instagram: 'https://www.instagram.com/mewa_textilservice/',
        // x: 'https://x.com/mewa_ch',
        // xing: 'https://www.xing.com/pages/mewa',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
        excludedServiceSegments: [
          ServiceSegmentType.cleanRoomClothing,
          ServiceSegmentType.cleanRoomAccessories,
          ServiceSegmentType.cleanRoomCleaning,
          ServiceSegmentType.cleanRoomTrainings,
        ],
      },
      {
        code: Language.IT,
        cmsFallback: Market.IT,
        domain: 'https://www.mewa.ch',
        langPrefix: Market.IT,
        // localizedMarketName: 'Mewa Svizzera',
        // localizedLanguageLabel: 'Italiano',
        // customerPortal: 'https://my.mewa.ch/it/login',
        // careerPortal: 'https://mewa.jobs/it',
        // onlineShop: 'https://buy4work.mewa.shop/ch/it',
        // facebook: 'https://www.facebook.com/MEWADienstleistung/',
        // instagram: 'https://www.instagram.com/mewa_textilservice/',
        // x: 'https://x.com/mewa_ch',
        // xing: 'https://www.xing.com/pages/mewa',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
        excludedServiceSegments: [
          ServiceSegmentType.cleanRoomClothing,
          ServiceSegmentType.cleanRoomAccessories,
          ServiceSegmentType.cleanRoomCleaning,
          ServiceSegmentType.cleanRoomTrainings,
        ],
      },
    ],
    serviceSegments: [
      ServiceSegmentType.protectiveClothing,
      ServiceSegmentType.serviceClothing,
      ServiceSegmentType.workwear,
      ServiceSegmentType.healthClothing,
      ServiceSegmentType.hygieneClothing,
      ServiceSegmentType.washroomHygiene,
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.dirtTrappingMats,
      ServiceSegmentType.cleaningCloths,
      ServiceSegmentType.carCovers,
      ServiceSegmentType.partsCleaner,
      ServiceSegmentType.cleanRoomClothing,
      ServiceSegmentType.cleanRoomAccessories,
      ServiceSegmentType.cleanRoomCleaning,
      ServiceSegmentType.cleanRoomTrainings,
    ].sort(compareServiceSegments),
    hasClothingSegments: true,
    countryCallingCode: '+41',
    maxEmployeeCountForSmallCompany: 124,
  },
  [Market.AT]: {
    languages: [
      {
        code: Language.DE,
        domain: 'https://www.mewa.at',
        // localizedMarketName: 'Mewa Österreich',
        // customerPortal: 'https://my.mewa.at/de/login',
        // careerPortal: 'https://mewa.jobs/',
        // onlineShop: 'https://buy4work.mewa.shop/at/de',
        // facebook: 'https://www.facebook.com/MEWADienstleistung/',
        // instagram: 'https://www.instagram.com/mewa_textilservice/',
        // x: 'https://x.com/mewa_at',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
        // xing: 'https://www.xing.com/pages/mewa',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // blog: 'https://www.mewa.de/blog',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.businessClothing,
      ServiceSegmentType.protectiveClothing,
      ServiceSegmentType.serviceClothing,
      ServiceSegmentType.workwear,
      ServiceSegmentType.healthClothing,
      ServiceSegmentType.hygieneClothing,
      ServiceSegmentType.washroomHygiene,
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.dirtTrappingMats,
      ServiceSegmentType.cleaningCloths,
      ServiceSegmentType.carCovers,
      ServiceSegmentType.wipingMops,
      ServiceSegmentType.partsCleaner,
      ServiceSegmentType.cleanRoomClothing,
      ServiceSegmentType.cleanRoomAccessories,
      ServiceSegmentType.cleanRoomCleaning,
      ServiceSegmentType.cleanRoomTrainings,
    ].sort(compareServiceSegments),
    hasClothingSegments: true,
    countryCallingCode: '+43',
    maxEmployeeCountForSmallCompany: 124,
  },
  [Market.BE]: {
    languages: [
      {
        code: Language.NL,
        domain: 'https://www.mewa.be',
        langPrefix: Language.NL,
        // localizedMarketName: 'Mewa België',
        // localizedLanguageLabel: 'Nederlands',
        // customerPortal: 'https://my.mewa.be/nl/login',
        // careerPortal: 'https://mewa.jobs/nl',
        // onlineShop: 'https://buy4work.mewa.shop/be/nl',
        // facebook: 'https://www.facebook.com/MEWABENELUX/',
        // x: 'https://x.com/mewa_be',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
      },
      {
        code: Language.FR,
        domain: 'https://www.mewa.be',
        langPrefix: Language.FR,
        // localizedMarketName: 'Mewa Belgique',
        // localizedLanguageLabel: 'Français',
        // customerPortal: 'https://my.mewa.be/fr/login',
        // careerPortal: 'https://mewa.jobs/fr',
        // onlineShop: 'https://buy4work.mewa.shop/be/fr',
        // facebook: 'https://www.facebook.com/MEWABENELUX/',
        // x: 'https://x.com/mewa_be',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.businessClothing,
      ServiceSegmentType.protectiveClothing,
      ServiceSegmentType.serviceClothing,
      ServiceSegmentType.workwear,
      ServiceSegmentType.healthClothing,
      ServiceSegmentType.hygieneClothing,
      ServiceSegmentType.washroomHygiene,
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.dirtTrappingMats,
      ServiceSegmentType.cleaningCloths,
      ServiceSegmentType.carCovers,
      ServiceSegmentType.partsCleaner,
    ].sort(compareServiceSegments),
    hasClothingSegments: true,
    countryCallingCode: '+32',
    maxEmployeeCountForSmallCompany: 124,
  },
  [Market.CZ]: {
    languages: [
      {
        code: Language.CS,
        domain: 'https://www.mewa.cz',
        // localizedMarketName: 'Mewa Česko',
        // customerPortal: 'https://my.mewa.cz/cs/login',
        // careerPortal: 'https://mewa.jobs/cz',
        // onlineShop: 'https://buy4work.mewa.shop/cz/cs',
        // facebook: 'https://www.facebook.com/mewacz/',
        // x: 'https://x.com/mewa_cz',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.protectiveClothing,
      ServiceSegmentType.serviceClothing,
      ServiceSegmentType.workwear,
      ServiceSegmentType.healthClothing,
      ServiceSegmentType.hygieneClothing,
      ServiceSegmentType.washroomHygiene,
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.dirtTrappingMats,
      ServiceSegmentType.cleaningCloths,
      ServiceSegmentType.carCovers,
      ServiceSegmentType.partsCleaner,
    ].sort(compareServiceSegments),
    hasClothingSegments: true,
    countryCallingCode: '+420',
    maxEmployeeCountForSmallCompany: 124,
  },
  [Market.PL]: {
    languages: [
      {
        code: Language.PL,
        domain: 'https://www.mewa-service.pl',
        // localizedMarketName: 'Mewa Polska',
        // customerPortal: 'https://my.mewa-service.pl/pl/login',
        // careerPortal: 'https://mewa.jobs/pl',
        // onlineShop: 'https://buy4work.mewa.shop/pl/pl',
        // x: 'https://x.com/mewa_pl',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.protectiveClothing,
      ServiceSegmentType.workwear,
      ServiceSegmentType.healthClothing,
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.cleaningCloths,
      ServiceSegmentType.partsCleaner,
    ].sort(compareServiceSegments),
    hasClothingSegments: true,
    countryCallingCode: '+48',
    maxEmployeeCountForSmallCompany: 124,
  },
  [Market.NL]: {
    languages: [
      {
        code: Language.NL,
        domain: 'https://www.mewa-service.nl',
        // localizedMarketName: 'Mewa Nederland',
        // customerPortal: 'https://my.mewa-service.nl/nl/login',
        // careerPortal: 'https://mewa.jobs/nl',
        // onlineShop: 'https://buy4work.mewa.shop/nl/nl',
        // facebook: 'https://www.facebook.com/MEWABENELUX/',
        // x: 'https://x.com/mewa_nl',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.protectiveClothing,
      ServiceSegmentType.serviceClothing,
      ServiceSegmentType.workwear,
      ServiceSegmentType.healthClothing,
      ServiceSegmentType.hygieneClothing,
      ServiceSegmentType.washroomHygiene,
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.dirtTrappingMats,
      ServiceSegmentType.cleaningCloths,
      ServiceSegmentType.carCovers,
      ServiceSegmentType.partsCleaner,
    ].sort(compareServiceSegments),
    hasClothingSegments: true,
    countryCallingCode: '+31',
    maxEmployeeCountForSmallCompany: 99,
  },
  [Market.ES]: {
    languages: [
      {
        code: Language.ES,
        // localizedMarketName: 'Mewa España',
        // localizedLanguageLabel: 'Español',
        domain: 'https://www.mewa.es',
        // customerPortal: 'https://my.mewa.es/es/login',
        // careerPortal: 'https://mewa.jobs/es',
        // onlineShop: 'https://buy4work.mewa.shop/es/es',
        // facebook: 'https://www.facebook.com/MewaIberia',
        // x: 'https://x.com/mewa_es',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
      },
      {
        code: Language.CA,
        // localizedMarketName: 'Mewa Cataluña',
        // localizedLanguageLabel: 'Catalán',
        domain: 'https://www.mewa.cat',
        // customerPortal: 'https://my.mewa.es/es/login',
        // careerPortal: 'https://mewa.jobs/es',
        // onlineShop: 'https://buy4work.mewa.shop/es/es',
        // facebook: 'https://www.facebook.com/MewaIberia',
        // x: 'https://x.com/mewa_es',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.cleaningCloths,
      ServiceSegmentType.partsCleaner,
    ].sort(compareServiceSegments),
    hasClothingSegments: false,
    countryCallingCode: '+34',
    maxEmployeeCountForSmallCompany: 89,
  },
  [Market.SK]: {
    languages: [
      {
        code: Language.SK,
        domain: 'https://www.mewa.sk',
        // localizedMarketName: 'Mewa Slovensko',
        // customerPortal: 'https://my.mewa.sk/sk/login',
        // careerPortal: 'https://mewa.jobs/sk',
        // x: 'https://x.com/mewa_sk',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.cleaningCloths,
    ].sort(compareServiceSegments),
    hasClothingSegments: false,
    countryCallingCode: '+421',
    maxEmployeeCountForSmallCompany: 124,
  },
  [Market.RO]: {
    languages: [
      {
        code: Language.RO,
        domain: 'https://www.mewa.ro',
        // localizedMarketName: 'Mewa România',
        // customerPortal: 'https://my.mewa.ro/ro/login',
        // careerPortal: 'https://mewa.jobs/ro',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.cleaningCloths,
    ].sort(compareServiceSegments),
    hasClothingSegments: false,
    countryCallingCode: '+40',
    maxEmployeeCountForSmallCompany: 124,
  },
  [Market.PT]: {
    languages: [
      {
        code: Language.PT,
        domain: 'https://www.mewa.pt',
        // localizedMarketName: 'Mewa Portugal',
        // customerPortal: 'https://my.mewa.pt/pt/login',
        // careerPortal: 'https://mewa.jobs/pt',
        // x: 'https://x.com/mewa_pt',
        // youtube:
        //   'https://www.youtube.com/channel/UCFfTC45AWh5BTBomPvN-_3A/playlists',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.cleaningCloths,
    ].sort(compareServiceSegments),
    hasClothingSegments: false,
    countryCallingCode: '+351',
    maxEmployeeCountForSmallCompany: 89,
  },
  [Market.GB]: {
    languages: [
      {
        code: Language.EN,
        domain: 'https://www.mewa.co.uk',
        // localizedMarketName: 'Mewa United Kingdom',
        // customerPortal: 'https://my.mewa.co.uk/en/login',
        // careerPortal: 'https://mewa.jobs/en/',
        // x: 'https://x.com/MEWA_EN',
        // youtube:
        //   'https://www.youtube.com/playlist?list=PLLr2ewvdC_9p40PCCqoqeXMMS5XrIcAWI',
        // linkedin: 'https://de.linkedin.com/company/mewa-textil-management',
      },
    ],
    serviceSegments: [
      ServiceSegmentType.oilCollectionMats,
      ServiceSegmentType.cleaningCloths,
      ServiceSegmentType.partsCleaner,
    ].sort(compareServiceSegments),
    hasClothingSegments: false,
    countryCallingCode: '+44',
    maxEmployeeCountForSmallCompany: 124,
  },
};
